/**
 * alexludwing.test main Javascript
 */
import "_navigation";
import "_fancybox";
